// Shared formatting + constants used across the extracted MarketForge components.
// Keep this small and dependency-free so it can be safely imported anywhere
// without dragging in React/charting libraries.

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const COLORS = {
  bg:      "#08080A",
  panel:   "#121216",
  border:  "#26262B",
  text:    "#E4E4E7",
  muted:   "#8A8A93",
  green:   "#00FF88",
  red:     "#FF3366",
  amber:   "#FFB800",
  blue:    "#3BB5FF",
};

export function fmtMoney(v) {
  if (v == null || !Number.isFinite(Number(v))) return "—";
  return Number(v).toLocaleString(undefined, { style: "currency", currency: "USD", maximumFractionDigits: 2 });
}

export function fmtPct(v) {
  if (v == null || !Number.isFinite(Number(v))) return "—";
  return `${Number(v).toFixed(2)}%`;
}

export function fmtNum(v, dp = 1) {
  if (v == null || !Number.isFinite(Number(v))) return "—";
  return Number(v).toFixed(dp);
}

// Iter119.25 — Lives here (not in GEXPanel.js) so StrategyTracker can
// consume the same palette without creating a circular import.
// GEXPanel.js re-exports this symbol for back-compat with any external
// consumer that still imports it from there.
export const GEX_CLASS_COLORS = {
  PREMIUM_ROTATION_CSP: "#00FF88",
  NORMAL_CSP:           "#3BB5FF",
  NEUTRAL:              "#8A8A93",
  ASSIGNMENT_ACCEPTED:  "#FFB800",
  DANGER_PREMIUM:       "#FF3366",
  NO_DATA:              "#5F5F66",
};

